<template>
	<v-badge small :color="getSuspendDataProgressColor(suspendDataPercentage)" :value="isSuspennDataAboveThreshold">
		<template v-slot:badge>
			<span>
				<v-icon small>mdi-exclamation</v-icon>
			</span>
		</template>
		<v-icon>mdi-package-variant-closed</v-icon>
	</v-badge>
</template>

<script>
const MID_THRESHOLD = 50
const HIGH_THRESHOLD = 75
const MAX_DATA_SIZE = 65536
export default {
	inject: ['lessonPlanController'],
	data() {
		return {
			suspendDataSizeInBytes: 0,
			suspendDataPercentage: 0
		}
	},
	created() {
        this.suspendDataSizeInBytes = this.lessonPlanController.compressedActivityState.length
        this.suspendDataPercentage = (this.suspendDataSizeInBytes / MAX_DATA_SIZE) * 100

        if (this.suspendDataPercentage > 100) this.suspendDataPercentage = 100        
	},
	methods: {
		getSuspendDataProgressColor(percentage) {
			if (percentage > HIGH_THRESHOLD) return 'error'
			if (percentage > MID_THRESHOLD) return 'warning'
			return 'success'
		},
	},
	computed: {
		isSuspennDataAboveThreshold() {
			return this.suspendDataPercentage > MID_THRESHOLD;
		}
	}
};
</script>
